import { Navigate, useLocation } from 'react-router-dom';
import Loadable from 'components/Loadable';
import { useAuth } from '../lib/auth';
import { APP_DEFAULT_PATH } from 'config';
import { Box, CircularProgress } from '@mui/material';

const LoginPage = Loadable(() => import('pages/auth/Login'));
const RegisterPage = Loadable(() => import('pages/auth/Register'));
const RegisterHostPage = Loadable(() => import('pages/auth/RegisterHost'));

function LoginGate() {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <Box sx={{ minHeight: '50vh', display: 'grid', placeItems: 'center' }}>
        <CircularProgress />
      </Box>
    );
  }

  // If logged in, send them to where they were trying to go (deep link),
  // otherwise fall back to APP_DEFAULT_PATH.
  if (user) {
    const fromLoc = location.state?.from;

    const fromState =
      fromLoc?.pathname && fromLoc.pathname !== '/login'
        ? `${fromLoc.pathname}${fromLoc.search || ''}${fromLoc.hash || ''}`
        : null;

    let fromStorage = null;
    try {
      fromStorage = sessionStorage.getItem('postLoginRedirect');
    } catch {
      // ignore
    }

    const redirectTo = fromState || fromStorage || APP_DEFAULT_PATH;

    try {
      sessionStorage.removeItem('postLoginRedirect');
    } catch {
      // ignore
    }

    return <Navigate to={redirectTo} replace />;
  }

  return <LoginPage />;
}

// Export an ARRAY of route objects (top-level paths)
const LoginRoutes = [
  { path: '/login', element: <LoginGate /> },
  { path: '/register', element: <RegisterPage /> },
  { path: '/register-host', element: <RegisterHostPage /> }
];

export default LoginRoutes;
